import { Stack, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { formatNumber } from "../../../../../../common/utils";
import { EmissionsHaulageTransportResultsDTO } from "../../../../../../datasources/api-client/data-contracts";
import { headerCellMeasure, MeasureTypes } from "../../../../utils";
import { EmissionDataKey, getTransportTypeIcon } from "../../Greenrouter/data";

const capitalize = (str: string) => {
	if (!str) return "";
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const getRowsTransport = (data: EmissionsHaulageTransportResultsDTO, selectMeasure: string, t: TFunction) => {
	const totalWeight = data.total.weight.value;
	const totalEmissions = data?.total?.[selectMeasure as EmissionDataKey]?.value;

	return (
		data &&
		Object.entries(data)
			.filter(([type, value]) => type !== "total" && value != null)
			.map(([type, value], index) => ({
				id: index,
				type: t(`transportType/${type}`),
				iconType: type,
				weight: {
					value: value.weight.value,
					percent: totalWeight !== 0 ? (value.weight.value / totalWeight) * 100 : 0,
				},
				emissions: {
					value: value[selectMeasure as EmissionDataKey].value,
					percent:
						totalEmissions && totalEmissions !== 0
							? (value[selectMeasure as EmissionDataKey].value / totalEmissions) * 100
							: 0,
				},
			}))
	);
};

export const dataColTransport: GridColDef[] = [
	{
		field: "type",
		headerName: "type of transport",
		flex: 1,
		sortable: false,
		renderCell: (params) => (
			<Stack direction="row" spacing={1} alignItems="center" height={"100%"}>
				{getTransportTypeIcon(params.row.iconType)}
				<Typography variant="body1">{capitalize(params.value)}</Typography>
			</Stack>
		),
	},
	{
		field: "emissions",
		headerName: "emissions",
		flex: 1,
		sortable: false,
		renderCell: (params) => {
			return params ? (
				<Stack spacing={1} height={"100%"} direction={"row"} justifyContent={"flex-end"} alignItems={"center"}>
					<Typography variant="body1" fontWeight={700}>
						{formatNumber(params.value.value, "decimal", 2, 2)}
					</Typography>
					<Typography variant="caption" color="text.secondary">
						({formatNumber(params.value.percent / 100, "percent", 2, 2)})
					</Typography>
				</Stack>
			) : (
				<>-</>
			);
		},
	},
	{
		field: "weight",
		headerName: "weight",
		flex: 1,
		sortable: false,
		renderCell: (params) => {
			return params ? (
				<Stack spacing={1} height={"100%"} direction={"row"} justifyContent={"flex-end"} alignItems={"center"}>
					<Typography variant="body1" fontWeight={700}>
						{formatNumber(params.value.value, "decimal", 2, 2)}
					</Typography>
					<Typography variant="caption" color="text.secondary">
						({formatNumber(params.value.percent / 100, "percent", 2, 2)})
					</Typography>
				</Stack>
			) : (
				<>-</>
			);
		},
	},
];

export const getColumnsTransport = (
	dataCol: GridColDef[],
	dataSample: MeasureTypes,
	t: TFunction,
	overrideFields?: (old?: string) => string | undefined
) =>
	dataCol.map((col) => ({
		...col,
		headerName: t(col.headerName ?? "-"),
		renderHeader: () => (
			<Stack
				direction="row"
				sx={{
					fontWeight: "bold",
				}}
				spacing={1}
				alignItems={"baseline"}
			>
				<Typography variant="subtitle1">{t(col.headerName ?? "-")}</Typography>
				<Typography variant="body2" color="text.secondary">
					{headerCellMeasure(col, dataSample, overrideFields)}
				</Typography>
			</Stack>
		),
	}));
